<ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
<div id="fl-main-showcase-container">
    <div>
        <div id="content-showcase-container">
            <img id="phone-frame-img" src="assets/images/iphone-transparent.png" alt="">
            <div id="inner-showcase-container">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>